import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['overlay']

  connect() {
    if (localStorage.getItem('promo_modal_dismissed')) {
      this.element.remove()
    }
  }

  close() {
    localStorage.setItem('promo_modal_dismissed', 'true')
    this.element.remove()
  }
}
